export class Analytic {
    title: String;
    data?: any;
    hide?: boolean;
    isShow?: boolean;

    constructor(obj) {
        this.title = obj.title;
        this.hide = true;
        this.data = obj;
        this.isShow = obj.isShow
    }

    static fromJSONArray(array: Array<Analytic>): Analytic[] {
        return array.map(obj => new Analytic(obj));
    }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/shared/analytic.ts